export const PICTURE_WORDS_CATEGORY = "Picture Words";

export interface PictureWordsItem {
  name: string;
  svg?: string;
}
